import React, { type ReactElement } from 'react';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { hasAuthorizationInfo } from 'reactApp/appHelpers/featuresHelpers/features/superAppAuthorizationInfo';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { ECloneToCloudButtonLocation } from 'reactApp/modules/modifying/modifying.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { SaveToCloudIcon, SaveToCloudIconBlack } from 'reactApp/ui/touchIcons';
import { PostMessageTypes, superAppPostMessage } from 'reactApp/utils/superAppWebViewHelpers';
import { EQueryParams } from 'server/helpers/getRequestParams';

import styles from './ViewerSaveToCloudButton.css';

interface IProps {
    isDark?: boolean;
}

const state = reduxStore.getState();
const fromDeeplink = getQueryParams()[EQueryParams.fromDeeplink];
const isSuperAppWebView = Boolean(IS_WEBVIEW) && fromDeeplink;
const isAnonymous = UserSelectors.isAnonymous(state);
const disableButton: boolean = isSuperAppWebView && isAnonymous && hasAuthorizationInfo(isAnonymous);

export const ViewerSaveToCloudButton = ({ isDark }: IProps): ReactElement => {
    const saveToCloud = () => {
        if (disableButton) {
            return superAppPostMessage(PostMessageTypes.authorization);
        }
        return toolbarActions.clone({
            source: 'header',
            button_location: ECloneToCloudButtonLocation.headerRight,
        });
    };

    return (
        <div className={styles.root}>
            <Button onClick={saveToCloud} primary={isDark} light={!isDark} theme="octavius" sizeMode={ButtonSizeMode.smallNarrow}>
                {isDark ? (
                    <SaveToCloudIcon className={styles.icon} height={15} width={17} fill="currentColor" />
                ) : (
                    <SaveToCloudIconBlack className={styles.icon} height={15} width={17} fill="currentColor" />
                )}
                <span className={styles.text}>{navigator.language.startsWith('ru') ? 'Сохранить в Облако' : 'Save to Cloud'}</span>
            </Button>
        </div>
    );
};
